import { render, staticRenderFns } from "./Ikon.vue?vue&type=template&id=412c6ca8&"
import script from "./Ikon.vue?vue&type=script&lang=js&"
export * from "./Ikon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports